export enum BotSkill {
    LOW = 0.3,
    MEDIUM = 0.6,
    HIGH = 1.0  
}

export type BotProfile = {
    id: number;
    name?: string;
    skill: BotSkill;
}
